<template>
  <div class="cg-item">
    <NuxtLink
      :aria-label="`Show all ${item.title} skins`"
      :to="localePath(`/colors/${getModifiedString(item.title)}`)"
      class="cg-item-link"
    />
    <div
      :style="{ '--color': replaceColor(item.hex) }"
      class="cg-item-image"
    >
      <Thumb
        :font-size="14"
        :height="11"
        :item="{} as ItemsByField"
        :size="14"
        :src="getImageFromWaxpeer(image)"
      />
    </div>
    <div class="f mta">
      <div class="cg-item-info">
        <p class="cg-item-name">
          {{ t(`color_translates.${getModifiedString(item.title).replace('-', '_')}`) }}
        </p>
        <span class="cg-item-count">
          {{ item.count }}
        </span>
      </div>
      <div
        :style="{ '--color': replaceColor(item.hex) }"
        class="circle"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ItemCountByColor, ItemsByField } from '~/graphql/generated/schema-types';
import Thumb from '~/components/Pages/Item/Components/Children/Thumb.vue';

defineProps<{
  image: string
  item: ItemCountByColor
}>();

const localePath = useLocalePath();
const { t } = useI18n();

function replaceColor(color: string) {
  switch (color) {
    case '#FF6900':
      return '#a64400';
    case '#FFFF00':
      return '#b7b700';
    case '#FF0000':
      return '#ae4141';
    case '#8C6600':
      return '#826006';
    case '#008000':
      return '#016501';
    default:
      return color;
  }
}
</script>

<style lang="scss" scoped>
.cg-item {
  padding: 16px;
  border-radius: 12px;
  background: var(--surfaces-low-container);
  position: relative;
  display: flex;
  flex-direction: column;

  &:hover {
    :deep(.thumb_bg) {
      color: var(--color);
    }

    :deep(.thumb) img {
      scale: 1.1;
    }
  }

  &:deep(.thumb_bg) {
    color: var(--surfaces-outline);
  }

  &:deep(.thumb) img {
    transition: 0.3s scale;
  }

  &-link {
    position: absolute;
    inset: 0;
    z-index: 1;
  }

  &-image {
    margin-bottom: 10px;
  }

  &-name {
    font-size: 14px;
    font-weight: 600;
    line-height: 128.571%;
    margin-bottom: 4px;
  }

  &-count {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: var(--surfaces-on-surface-variable);
  }

  .circle {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 6px solid var(--color);
    box-sizing: border-box;
    background-color: transparent;
    flex-shrink: 0;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      top: -6px;
      bottom: -6px;
      left: 50%;
      transform: translateX(-50%);
      display: block;
      width: 3px;
      background: var(--accent-on-primary);
    }
  }
}
</style>
